import { gql } from "@apollo/client";

export const UPCOMING_MEMBER_ELECTION_DATES_QUERY = gql`
  query UpcomingMemberElectionDates {
    upcomingMemberElectionDates {
      id
      electionDate
    }
  }
`;

export const ADD_MEMBER_ELECTION_DATE_MUTATION = gql`
  mutation AddMemberElectionDate($input: AddMemberElectionDateInput!) {
    addMemberElectionDate(input: $input) {
      success
      message
      electionDate {
        id
        electionDate
      }
    }
  }
`;

export const UPDATE_MEMBER_ELECTION_DATE_MUTATION = gql`
  mutation UpdateMemberElectionDate($input: UpdateMemberElectionDateInput!) {
    updateMemberElectionDate(input: $input) {
      success
      message
      electionDate {
        id
        electionDate
      }
    }
  }
`;

export const DELETE_MEMBER_ELECTION_DATE_MUTATION = gql`
  mutation DeleteMemberElectionDate($input: DeleteMemberElectionDateInput!) {
    deleteMemberElectionDate(input: $input) {
      success
      message
    }
  }
`;
